<template>
    <div class="roleManagementSearch">
        <Row :gutter="4">
            <Col span="4">
                <!-- v-on:input实时查询 -->
                <Input search v-model="roleManagementSearchKey" :placeholder="$t('permission_configuration_management.role.checkByRoleName')" @on-search="searchRoleManagement()"/>
            </Col>
            <!-- 选择公司 -->
            <div v-if="company==1">
              <Col span="4">
                  <Select v-model="companyId" filterable :placeholder="$t('permission_configuration_management.common.pleaseSelectCompany')" :transfer="true" @on-change="searchCompany">
                      <Option value=" " selected>{{$t('permission_configuration_management.common.all')}}</Option>
                      <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
                  </Select>
              </Col>
            </div>
            <Col span="2">
                <Button type="primary" @click="addOrUpdateHandle" v-hasPermission="['permissionsConfigurationManagement:roleManagement:add_role']">{{ $t('permission_configuration_management.role.addRole') }}</Button>
                <add-or-update-role-management v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-role-management>
            </Col>
        </Row>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../../utils/cookieUtil.js'
    import AddOrUpdateRoleManagement from '../role_management/AddOrUpdateRoleManagement'
    import TableRoleManagement from '../role_management/TableRoleManagement'
    var tableRoleManagement = TableRoleManagement;
    export default {
        name: 'RoleManagementSearch',
        components: {
            AddOrUpdateRoleManagement
        },
        data () {
            return {
                addOrUpdateVisible:false,
                company: getCookie(global.companyId),
                companyId: '',
                companyList: [],
                roleManagementSearchKey:'',
                roleManagementSearchName:''
            }
        },
        mounted: function(){
            if (this.company == 1) {
                this.getCompanyDropDownBox();
            }
        },
        methods: {
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
               this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                 .then(res => {
                     this.companyList = res.data;
                 });
             },
            // 按公司搜索
            searchCompany: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('companyId', this.companyId);
                tableRoleManagement.methods.showAll();
            },
            searchRoleManagement: function(){
                // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
                eventBus.$emit('roleManagementSearchName', this.roleManagementSearchKey);
                tableRoleManagement.methods.showAll();
            },
            // 添加
            /**********************************************************/
            addOrUpdateHandle:function(){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$router.push({path:'/permissionsConfigurationManagement/addOrUpdateRoleManagement'});
                })
            }
        }
    }
</script>
<style scoped>
    .roleManagementSearch
    {
        padding: 4px 0px 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/role_management/RoleManagementSearch.vue